import { render, staticRenderFns } from "./kdAccountUnitWritePermanentSolutionAudit.vue?vue&type=template&id=dc6f77e2&scoped=true"
import script from "./kdAccountUnitWritePermanentSolutionAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./kdAccountUnitWritePermanentSolutionAudit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6f77e2",
  null
  
)

export default component.exports